export const getGeocoderAPI = (searchInputText, type) => {
  const query = encodeURIComponent(searchInputText)
  return `https://gateway.idealagent.dev/autocomplete?query=${query}&search-type=${type}`
}
